import * as actionTypes from '../constantes/actionTypes';
import { AnalysisError, CliniqueState, Sensitivity, SkinType, StepView, UVprotection } from '../type';
// import testImage from "../assets/Images/AdamWithInv.jpg"

const initalState: CliniqueState = {
	session: {
		stepView: StepView.onBoard,
		isMicrosite: false,
		isShadematch: false,
		market: 'US',
		imageUser: null,
		wristImageUser: null,
		retailer: null,
		analyseStep: 0,
		biometrics: null,
		sessionID: '',
		predictions: null,
		error: [],
		analyses: [
			{ name: "irritation", score: 0.365034 },
			{ name: "blemishes", score: 0.4 },
			{ name: "fatigue", score: 0.6 },
			{ name: "lines_wrinkles", score: 0.5952355714285714 },
			{ name: "uneven_skintone", score: 0.344971 },
			{ name: "pores_uneven_structure", score: 0.243158 },
			{ name: "loss_of_volume", score: 0.205 },
			{ name: "dehydration", score: -1 },
		],
		recommendations: [],
		demkyInvisibleDamage: null,
		demkyWrinklesVisualization: null,
		skinType: SkinType.veryOily,
		uvProtection: UVprotection.builtIn,
		sensitivity: Sensitivity.never
	},
};

const reducer = (state = initalState, action: any) => {
	let nextState: CliniqueState;

	switch (action.type) {
		case actionTypes.UPDATE_MINDSTIX_RECO:
			nextState = {
				session: {
					...state.session,
					MindStixReco: action.value,
				},
			};

			return nextState;
		case actionTypes.SET_PREDICTIONS:
			nextState = {
				session: {
					...state.session,
					predictions: action.value,
				},
			};
			return nextState;

		case actionTypes.UPDATE_RETAILER:
			nextState = {
				session: {
					...state.session,
					retailer: action.value,
				},
			};

			return nextState;

		case actionTypes.UPDATE_SESSION_ID:
			nextState = {
				session: {
					...state.session,
					sessionID: action.value,
				},
			};

			return nextState;

		case actionTypes.UPDATE_ALL_RECOMMENDATION:
			nextState = {
				session: {
					...state.session,
					recommendations: action.value,
				},
			};

			return nextState;

		case actionTypes.UPDATE_RECOMMENDATIONS:
			let _recommendations = [...state.session.recommendations];
			_recommendations.push(action.value);

			nextState = {
				session: {
					...state.session,
					recommendations: _recommendations,
				},
			};
			console.warn(_recommendations)
			return nextState;

		case actionTypes.SET_MARKET:
			nextState = {
				session: {
					...state.session,
					market: action.value,
				},
			};
			return nextState;

		case actionTypes.SET_MICROSITE:
			nextState = {
				session: {
					...state.session,
					isMicrosite: action.value,
				},
			};
			return nextState;

		case actionTypes.SET_SHADEMATCH:
			nextState = {
				session: {
					...state.session,
					isShadematch: action.value,
				},
			};
			return nextState;

		case actionTypes.UPDATE_DEMKY_INVISIBLE_DAMAGE:
			nextState = {
				session: {
					...state.session,
					demkyInvisibleDamage: action.value,
				},
			};
			return nextState;

		case actionTypes.UPDATE_DEMKY_WRINKLES_VISUALIZATION:
			nextState = {
				session: {
					...state.session,
					demkyWrinklesVisualization: action.value,
				},
			};
			return nextState;

		case actionTypes.UPDATE_PREDICTIONS:
			nextState = {
				session: {
					...state.session,
					predictions: action.value,
				},
			};
			return nextState;

		case actionTypes.REMOVE_ANALYSIS_WARNINGS:
			nextState = {
				session: {
					...state.session,
					error: [],
				},
			};
			return nextState;

		case actionTypes.SET_SKIN_TYPE:
			nextState = {
				session: {
					...state.session,
					skinType: action.value,
				},
			};
			return nextState;

		case actionTypes.SET_UV_PROTECTION:
			nextState = {
				session: {
					...state.session,
					uvProtection: action.value,
				},
			};
			return nextState;

		case actionTypes.SET_SENSITIVITY:
			nextState = {
				session: {
					...state.session,
					sensitivity: action.value,
				},
			};
			return nextState;

		case actionTypes.SWITCH_STEP:
			nextState = {
				session: {
					...state.session,
					stepView: action.value,
				},
			};
			return nextState;

		default:
			return state;

		case actionTypes.ANALYSE_PHOTO:
			nextState = {
				...state,
				session: {
					...state.session,
					imageUser: action.value,
				},
			};
			return nextState;

		case actionTypes.ANALYSE_WRIST_PHOTO:
			nextState = {
				...state,
				session: {
					...state.session,
					wristImageUser: action.value,
				},
			};
			return nextState;

		case actionTypes.ANALYSE_ERROR:
			nextState = {
				...state,
				session: {
					...state.session,
					imageUser: null,
					error: action.value,
				},
			};
			return nextState;

		case actionTypes.NO_WARNING:
			nextState = {
				...state,
				session: {
					...state.session,
					error: [AnalysisError.no_error],
				},
			};
			return nextState;

		case actionTypes.ANALYSE_UPDATE:
			nextState = {
				...state,
				session: {
					...state.session,
					analyseStep: action.value,
				},
			};
			return nextState;

		case actionTypes.ANALYSE_BIOMETRICS_DONE:
			if (state.session.stepView === 2) {
				nextState = {
					...state,
					session: {
						...state.session,
						biometrics: action.value,
					},
				};
			} else {
				nextState = state;
			}

			return nextState;
		case actionTypes.SET_ANALYSIS:
			nextState = {
				...state,
				session: {
					...state.session,
					analyses: action.value,
				},
			};
			console.warn(nextState.session.analyses);
			return nextState;

	}
};

export default reducer;
